import { useMiddlewareProfile } from '@entities/viewer'
import { useMiddlewareAuth } from '@shared/api'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const authResult = await useMiddlewareAuth(to)
  if (authResult) return authResult

  await useMiddlewareProfile()
})
